
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cyber_cookie_consent');
    if (!consent) {
      // Delay slightly for aesthetics
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cyber_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cyber_cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full z-[100] p-4 md:p-6 animate-slide-up">
      <div className="max-w-7xl mx-auto bg-white border-2 border-black shadow-[0_-4px_30px_rgba(0,0,0,0.15)] p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 relative">
        
        {/* Decorative corner */}
        <div className="absolute top-0 left-0 w-4 h-4 bg-black"></div>

        <div className="flex-1">
            <div className="flex items-center gap-2 mb-3 text-xs font-bold uppercase tracking-widest text-black">
                <ShieldCheck size={14} /> Protocollo Privacy
            </div>
            <p className="text-sm font-serif text-gray-600 leading-relaxed max-w-2xl">
                Questo nodo digitale utilizza cookie e tecnologie di tracciamento per analizzare il traffico e garantire la persistenza dei dati locali. 
                Il rispetto della tua privacy è parte del nostro manifesto.
            </p>
            <div className="flex gap-4 mt-3 text-[10px] font-bold uppercase tracking-widest text-gray-400">
                <Link to="/legal" className="hover:text-black underline decoration-1 underline-offset-2">Privacy Policy</Link>
                <Link to="/legal" className="hover:text-black underline decoration-1 underline-offset-2">Cookie Policy</Link>
                <Link to="/legal" className="hover:text-black underline decoration-1 underline-offset-2">Termini Servizio</Link>
            </div>
        </div>

        <div className="flex flex-row gap-4 shrink-0 w-full md:w-auto">
            <button 
                onClick={handleDecline} 
                className="flex-1 md:flex-none px-6 py-3 border border-gray-300 text-gray-500 hover:text-black hover:border-black text-xs font-bold uppercase tracking-widest transition-colors"
            >
                Rifiuta
            </button>
            <button 
                onClick={handleAccept} 
                className="flex-1 md:flex-none px-8 py-3 bg-black text-white hover:bg-gray-800 text-xs font-bold uppercase tracking-widest shadow-lg transition-colors flex items-center justify-center gap-2"
            >
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse"></span>
                Accetta Tutto
            </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
